import { defaultUrlConfig } from '@celito.clients/endpoints';

import { resultModuleRegex } from '../consts/constants';
import {
  FacetObject,
  ResultCardObject,
  SelectedFacetsObject,
  SelectedSortObject,
} from '../search-result.model';

export const isAnyFacetSelected = (
  selectedFacetList: SelectedFacetsObject[]
) => {
  return (
    selectedFacetList.reduce((result: string[], item: SelectedFacetsObject) => {
      return result.concat(item.values);
    }, []).length > 0
  );
};

// Builds an absolute detail view URL from the current pathname.
// The search page sits at .../custom/search, so the relative ../view/ pattern
// used in list views would resolve to .../custom/view/ (wrong).
// We strip the trailing custom/search segment to get the correct base.
export const getDetailsViewUrl = (
  detailViewName: string,
  recordName: string,
  version: string
) => {
  const currentPath = window.location.pathname;
  // Extract the module name from the URL (/md/:moduleName/...) and build an
  // absolute URL with default tab/subtab so search__s tab doesn't interfere
  const moduleMatch = currentPath.match(/^\/md\/([^/]+)\//);
  const moduleName = moduleMatch ? moduleMatch[1] : '';
  const base = moduleName
    ? `/md/${moduleName}/tb/default/stb/default`
    : currentPath.replace(/\/custom\/[^/]+\/?$/, '');
  const path = `${base}/view/${detailViewName}/${recordName}`;
  return version ? `${path}?version=${version}` : path;
};

export const isFacetOfSelectedModule = (
  facet: FacetObject,
  selectedModule: string | null
) => {
  return (
    facet.module === selectedModule?.replace(resultModuleRegex, '') ||
    (facet.module === 'All' &&
      selectedModule?.replace(resultModuleRegex, '') === 'All Application')
  );
};

export const getCurrentModule = (moduleName: string | undefined) => {
  let selectedModule = '';

  if (!moduleName || moduleName === defaultUrlConfig.defaultModuleName) {
    return '';
  }

  switch (moduleName) {
    case 'lms__a':
      selectedModule = 'User Learning';
      break;
    case 'admin__a':
      selectedModule = 'Platform';
      break;
    case 'controlled_docs__a':
      selectedModule = 'Controlled Documents';
      break;
    case 'qms__a':
      selectedModule = 'QMS';
      break;
    default:
      break;
  }

  return selectedModule;
};

export const getSelectedQuickFilterBasedOnApiResponse = (
  selectedQuickFilter: string,
  newQuickFilters: string[]
) => {
  return (
    newQuickFilters.find((quickFilter) =>
      quickFilter.includes(selectedQuickFilter)
    ) ?? newQuickFilters[0]
  );
};

export const getSortedResults = (
  searchResults: ResultCardObject[],
  selectedSortOption: SelectedSortObject
) => {
  const safeCompare = (a: string | null, b: string | null) => {
    if (!a && !b) return 0;
    if (!a) return 1;
    if (!b) return -1;
    return a.localeCompare(b);
  };

  if (!selectedSortOption) {
    return searchResults.sort((a, b) =>
      safeCompare(b.createdAtDate, a.createdAtDate)
    );
  }

  if (selectedSortOption.column === 'modifiedAtUtc') {
    return searchResults.sort((a, b) =>
      selectedSortOption.isAscending
        ? safeCompare(a.modifiedAtDate, b.modifiedAtDate)
        : safeCompare(b.modifiedAtDate, a.modifiedAtDate)
    );
  }

  return searchResults.sort((a, b) =>
    selectedSortOption.isAscending
      ? safeCompare(a.createdAtDate, b.createdAtDate)
      : safeCompare(b.createdAtDate, a.createdAtDate)
  );
};
